import type { Brand } from '@app/services/api.types';
import { countryOptions } from '@app/utils/constants';
import { Descriptions, Divider, Drawer, type DescriptionsProps, type DrawerProps } from 'antd';

export type BrandDrawerProps = DrawerProps & {
    data: Brand | null;
};

export const BrandDrawer = ({ data, ...props }: BrandDrawerProps) => {
    const detailsItems: DescriptionsProps['items'] = [
        {
            key: '1',
            label: 'Name',
            children: data?.name || '-',
        },
        {
            key: '2',
            label: 'Channel Partner',
            children: data?.channel_name || '-',
        },
        {
            key: '3',
            label: 'Admin Name',
            children: data?.contact_name || '-',
        },
        {
            key: '4',
            label: 'Admin Email',
            children: data?.contact_email || '-',
        },
        {
            key: '5',
            label: 'Admin Phone Number',
            children: data?.contact_telephone || '-',
        },
    ];

    const addressItems: DescriptionsProps['items'] = [
        {
            key: '1',
            label: 'Address Line 1',
            children: data?.address_line1 || '-',
        },
        {
            key: '2',
            label: 'Address Line 2',
            children: data?.address_line2 || '-',
        },
        {
            key: '3',
            label: 'City',
            children: data?.city || '-',
        },
        {
            key: '4',
            label: 'Country',
            children: data?.country
                ? countryOptions.find(({ value }) => value === data?.country)?.label
                : '-',
        },
        {
            key: '5',
            label: 'Post Code',
            children: data?.post_code || '-',
        },
    ];

    const renderDetailsTab = () => {
        return (
            <>
                <Descriptions
                    title="Details"
                    colon={false}
                    layout="vertical"
                    items={detailsItems}
                    column={2}
                />
                <Divider />
                <Descriptions
                    title="Address"
                    colon={false}
                    layout="vertical"
                    items={addressItems}
                    column={2}
                />
            </>
        );
    };

    return (
        <Drawer
            title={
                <>
                    <span>Brand Details</span>
                    {data?.id ? (
                        <div className="ant-drawer-header-meta">
                            <span>ID: {data?.id}</span>
                        </div>
                    ) : null}
                </>
            }
            size={700}
            closable={{ 'aria-label': 'Close Button' }}
            {...props}>
            {renderDetailsTab()}
        </Drawer>
    );
};

export default BrandDrawer;
